import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { COST_CENTER } from '../types/cost-center.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for CostCenter entity.
 * Stored in 'org/{orgId}/cost-center'.
 */
export const costCenterDescriptor = {
    name: COST_CENTER,
    label: 'Centro de Custo',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/cost-center',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Cost center for financial/organizational tracking',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique cost center identifier',
        },
        {
            name: 'code',
            label: 'Código',
            type: 'number',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric cost-center code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Cost center description',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=cost-center.descriptor.js.map